export default __webpack_public_path__ + "static/media/garnish-logo.0ea1b423.png";